import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Button from '@mui/material/Button';

export default function TextEditor({ data, hanldeUpdate }) {
    const contentDataState = ContentState.createFromBlockArray(convertFromHTML(data));
    const editorDataState = EditorState.createWithContent(contentDataState);
    const [editorState, setEditorState] = useState(editorDataState);
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const markup = draftToHtml(
        rawContentState
    );

    const changeHandle = (data) => {
        setEditorState(data)
    }
    useEffect(() => {
        setEditorState(editorDataState);
    }, [data])



    return (
        <div >
            <div style={{
                border: "1px solid lightgray",
                minHeight: '480px',
                color: "black",
                borderRadius: "10px",
                padding: "1rem 1.25rem",
                position: "relative"
            }}>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={(data) => changeHandle(data)}
                />
            </div>
            <Button variant="contained" size="small" sx={{ textTransform: "unset", fontSize: "70%", my: 2 }} onClick={() => { hanldeUpdate(markup) }}>Add / Update</Button>
        </div>
    );
}